import {
  faCircleCheck,
  faCircleInfo,
  faClock,
  faOctagonXmark
} from '@fortawesome/pro-duotone-svg-icons'

const KYC_STAGE = {
  INIT: 'init',
  DOCUMENT_UPLOADED: 'document_uploaded',
  DOCUMENT_REUPLOAD_REQUESTED: 'document_reupload_requested',
  SUCCESS: 'success',
  FAILED: 'failed',
  FAILED_DUPLICATE: 'failed_duplicate',
  FAILED_FRAUD: 'failed_fraud',
  NULL: null
}

const isKycIncomplete = ({ status }) => {
  return status !== KYC_STAGE.SUCCESS
}

const KYC_SESSION_URL = 'https://verify.synaps.io/?session_id='

const kycSessionUrl = (id) => {
  return KYC_SESSION_URL + id
}

const buildKYCStatus = ({ id, status }) => {
  switch (status) {
    case KYC_STAGE.FAILED:
    case KYC_STAGE.FAILED_DUPLICATE:
    case KYC_STAGE.FAILED_FRAUD:
      return {
        severity: 'error',
        title: 'kyc.verification-failed',
        icon: faOctagonXmark,
        support: true,
        disabled: true,
        hide: true
      }

    case KYC_STAGE.DOCUMENT_REUPLOAD_REQUESTED:
      return {
        severity: 'error',
        title: 'kyc.document-could-not-be-verified',
        icon: faOctagonXmark,
        disabled: false,
        refresh: true,
        support: false
      }

    case KYC_STAGE.INIT:
      return {
        severity: 'error',
        title: 'kyc.upload-docs',
        icon: faOctagonXmark,
        disabled: false,
        refresh: true,
        support: false
      }

    case KYC_STAGE.DOCUMENT_UPLOADED:
      return {
        severity: 'warning',
        title: 'kyc.process-pending',
        icon: faClock,
        disabled: true,
        refresh: true,
        support: false
      }

    case KYC_STAGE.SUCCESS:
      return {
        severity: 'success',
        title: 'kyc.successfully-completed',
        icon: faCircleCheck,
        disabled: true,
        hide: true,
        support: false
      }

    default:
      return {
        severity: id ? 'warning' : 'info',
        title: id ? 'kyc.process-pending' : 'kyc.process-not-started',
        icon: id ? faClock : faCircleInfo,
        disabled: false,
        refresh: id,
        support: false
      }
  }
}

const isFinalKycReview = (payload) => {
  const result = payload?.reviewResult
  const status = payload?.reviewStatus

  if (status !== 'completed' || !result) return false

  if (result.reviewAnswer === 'GREEN') {
    return true
  }

  if (result.reviewAnswer === 'RED' && result.reviewRejectType === 'FINAL') {
    return true
  }

  return false
}

export {
  buildKYCStatus,
  isKycIncomplete,
  KYC_STAGE,
  kycSessionUrl,
  isFinalKycReview
}
